import { Text } from '@ninjacart/nc-nk-ui';

interface WeatherWidgetProps {
  temperature: number;
  onPress: () => void;
}

export const WeatherWidget = ({ temperature, onPress }: WeatherWidgetProps) => {
  return (
    <>
      <Text color={'$lightGrey'} fontSize={22}>
        |
      </Text>
      <Text onPress={onPress} color={'$color'} paddingLeft={6} fontSize={20} fontWeight="bold">
        {temperature}°
      </Text>
    </>
  );
};
